import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "../../../api/api";
import { getCaseId, getClientId } from "../../../Utils/helper";

const useGetAllParties = ({ enabled = true } = {}) => {
  const [parties, setParties] = useState([]);
  const [client, setClient] = useState([]);
  const [defendant, setDefendant] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchParties = useCallback(async () => {
    const clientId = getClientId();
    const caseId = getCaseId();
    if (!clientId || !caseId) return;

    try {
      setLoading(true);
      setError(null);
      const res = await api_without_cancellation.get(`/api/otherparties/${clientId}/${caseId}/`);
      if (res.status === 200) {
        setParties(Array.isArray(res.data) ? res.data : res.data?.parties ?? []);
        setClient(Array.isArray(res.data) ? res.data : res.data?.clients ?? []);
        setDefendant(Array.isArray(res.data) ? res.data : res.data?.defendants ?? []);
      }
    } catch (err) {
      console.error("Failed to fetch other parties:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) fetchParties();
  }, [enabled, fetchParties]);

  return { parties, client, defendant, loading, error, refetch: fetchParties };
};

export default useGetAllParties;
